import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng';
import { UtilisateursService } from 'src/app/services/utilisateurs.service';

@Component({
  selector: 'app-invisible',
  templateUrl: './invisible.component.html',
  styleUrls: ['./invisible.component.css']
})
export class InvisibleComponent implements OnInit {

  listeOp : any[] = [];
  listeOpCol: any = [ // => Colonnes du tableau Suivi Global Temps Reel
    {field: 'matricule', header: 'Matricule'},
    {field: 'superviser', header: 'Statut supervision'},
  ];

  constructor(public ref: DynamicDialogRef, public conf: DynamicDialogConfig, private utilisateurService:UtilisateursService) { }

  ngOnInit(): void {
    this.utilisateurService.getListeOpDetails().subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
        let liste = value['data'];

        liste.forEach(current => {
          let currentOp = {
            matricule: current['matricule'],
            superviser : current['superviser']
          };

          this.listeOp.push(currentOp);
        });
      }
    });
  }



  supervisionStatut(superviser: boolean) {
    if(superviser === true ) {
      return 'customer-badge status-qualified';
    } else {
      return 'customer-badge status-unqualified';
    }
  }


  setSupervision(op:any) {
    let matricule:number = op['matricule'];
    let superviser: boolean = false;

    if(op['superviser'] === true) {
      superviser = false;
    } else {
      superviser = true;
    }

    this.utilisateurService.setSupervision(matricule, superviser)
    .subscribe((value) => {

      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
        this.listeOp = this.listeOp.map((current) => {
          if(current['matricule'] === matricule) {
            current['superviser'] = superviser;
          }
          return current;
        });
      }

    });
  }

}
